import {
  CustomizationPricingModelSchema,
  type CustomizationPricingModel as GeneratedCustomizationPricingModel
} from '~/services/api/generated'

export type CustomizationPricingModel = GeneratedCustomizationPricingModel

export const CustomizationPricingModel = {
  EACH: CustomizationPricingModelSchema.enum.each,
  WEIGHT: CustomizationPricingModelSchema.enum.weight,
  PERCENTAGE: CustomizationPricingModelSchema.enum.percentage
} satisfies Record<string, GeneratedCustomizationPricingModel>

export const CustomizationPricingModelValues: readonly GeneratedCustomizationPricingModel[] = [
  CustomizationPricingModelSchema.enum.each,
  CustomizationPricingModelSchema.enum.weight,
  CustomizationPricingModelSchema.enum.percentage
]
